import $ from 'jquery';
import 'semantic-ui-calendar/dist/calendar';
import 'semantic-ui-calendar/dist/calendar.css';

var TimePicker = (function () {
  'use strict';

  var init = function () {
    $('.js__timepicker-init').calendar({
      type: 'time',
      ampm: false,
    });
  };

  return {
    init: init,
  };
})();

export default TimePicker;
